"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var componentStyle = {
    base: {
        padding: '22px',
        color: '#727272',
        fontWeight: 300,
    },
};
exports.CardBody = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({ style: componentStyle.base }, otherProps), children));
};
exports.CardBody.displayName = 'CardBody';



//////////////////
// WEBPACK FOOTER
// ./src/components/Card/CardBody.tsx
// module id = 283
// module chunks = 0